module.exports = __webpack_public_path__ + "img/section4Content5.2a9e9bfa.png";